export default class AddUserCommentCtrl {
  constructor ($scope, $mdDialog, PortfolioSrv, PortfolioModalSrv, WorkPlanSrv, GlobalConfig, GlobalSrv) {
  // constants
    var commentUserVm = this
    const sharedVariable     = PortfolioModalSrv.getVariable()

    commentUserVm.ownerId    = sharedVariable.userId
    commentUserVm.userLogued = sharedVariable.guestUser
  // variables
    commentUserVm.comment = ''
    commentUserVm.disableButton = false

  // methods
    commentUserVm.close             = close
    commentUserVm.addComment        = addComment
    commentUserVm.showErrorMessages = showErrorMessages
    commentUserVm.hasError          = hasError
    commentUserVm.validateForm      = validateForm    

    function close () {
      PortfolioModalSrv.setVariable({status : false})
      return $mdDialog.hide()
    }  
    
    function getSendNotify(idUser){
      let post1 = {
          idUser: idUser,
          dsName: 'Notificación de comentario (Portafolio)',
          dsDescription: 'Se ha ingresado un comentario en su portafolio',
          idNotification_delivery_type: GlobalConfig.notificationType.inbox,
          is_grouped: 1
      }
      GlobalSrv.sendNotification(post1)
    }

    function addComment () {
      commentUserVm.disableButton = true
      let header = {
        commentUserId : commentUserVm.userLogued,
        comment       : commentUserVm.comment,
        ownerId       : commentUserVm.ownerId
      }

      PortfolioSrv.addUserComment.add(header).$promise.then((dataReturn) => {
        if (dataReturn.status) {
             getSendNotify(commentUserVm.ownerId)
             PortfolioModalSrv.setVariable({status : dataReturn.status})
             $mdDialog.hide()

        } else {
          commentUserVm.disableButton = false
        }
      })
    }

    function hasError (input) {
      if (input.$invalid && (input.$dirty || input.$touched)) {
        return 'has-error'
      }
    }

    function showErrorMessages (input) {
      return input.$dirty || input.$touched
    }

    function validateForm (form) {
      return form.$invalid
    }
  }
}

AddUserCommentCtrl.$inject = ['$scope', '$mdDialog', 'PortfolioSrv', 'PortfolioModalSrv', 'WorkPlanSrv', 'GlobalConfig', 'GlobalSrv']



// WEBPACK FOOTER //
// ./src/app/u-faculty/portfolio/myPortfolio/modals/addUserCommentCtrl.js